import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { Title } from '@angular/platform-browser';
import { NavigationStart, Router } from "@angular/router";
import { environment } from '../../../../environments/environment';
import { AppBuildInfo } from '../../../shared/models/admin/app-build-info.model';
import { Features } from '../../../shared/models/features.model';
import { AdminService } from '../../../shared/services/admin.service';
import { FeaturesService } from '../../../shared/services/features.service';

@Component({
    selector: 'admin-about',
    templateUrl: './admin-about.component.html',
    styleUrls: ['./admin-about.component.scss'],
    standalone: false
})

export class AdminAboutComponent implements OnInit {

    //TEAMS-424: KLW - Adding in a reference to MatAccordion to expand and collapse all expansion panels
    @ViewChild(MatAccordion) accordion: MatAccordion;

    constructor(private AdminAboutSvc: AdminService,
        private featuresService: FeaturesService,
        private router: Router,
        private readonly titleService: Title) {
    }

    public appBuildInfo: AppBuildInfo
    public features: Features[];


    ngOnInit(): void {
        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationStart) {

                }
            });
        this.AdminAboutSvc.appBuildInfo.then(result => { this.appBuildInfo = result; })

        this.featuresService.getFeatures().then(response => {
            this.features = response;
        });

        this.titleService.setTitle(environment.sitename + ' - About');
    }
}
